import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  topRow: {
    paddingBottom: 3,
  },
  bottomRow: {
    paddingTop: 3,
  },
  pdfLink: {
    paddingBottom: 10,
  },
});
